var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBigCircleGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#04bf2a;}.b{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75 -1314)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 827)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(74 487)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.752,16.659a1,1,0,0,1-1.376.122l-5-4a1,1,0,1,1,1.248-1.562l4.253,3.4,6.371-7.281a1,1,0,0,1,1.5,1.318Z",
    transform: "translate(79 1318)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBigCircleGreen);
export default __webpack_public_path__ + "static/media/check-big-circle-green.2b7110b0a368390d7d6a148b8e2d1667.svg";
export { ForwardRef as ReactComponent };